"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2080],{

/***/ 2080:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BlockDifference": function() { return /* binding */ BlockDifference; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4522);
/* harmony import */ var _ui_cursive_basic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4693);



var BlockDifferenceCheckListData = [
    {
        id: "1",
        title: "100% natural ingredients"
    },
    {
        id: "2",
        title: "No fillers, preservatives or additives"
    },
    {
        id: "3",
        title: "Rich in vital nutrients "
    },
    {
        id: "4",
        title: "Reduces need for supplements"
    },
    {
        id: "5",
        title: "Recommended by vets and pet nutritionists"
    },
    {
        id: "6",
        title: "Locally sourced, farm fresh"
    },
    {
        id: "7",
        title: "Premium quality at affordable prices"
    }
];
var BlockDifference = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ui__WEBPACK_IMPORTED_MODULE_1__/* .BackgroundWrap */ .e_, {
        className: "h-full bg-meat ",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ui__WEBPACK_IMPORTED_MODULE_1__/* .GradientWrap */ .Mx, {
            className: "h-full from-colorEight via-colorEight/80 to-transparent",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_ui__WEBPACK_IMPORTED_MODULE_1__/* .Wrapper */ .im, {
                className: "m-auto w-[80%] py-20",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "grid grid-cols-1 text-left sm:grid-cols-[2fr_1fr]",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ui__WEBPACK_IMPORTED_MODULE_1__/* .Title */ .Dx, {
                                className: "col-span-full text-colorFifteen",
                                children: "The Tucker Tub Difference"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ui_cursive_basic__WEBPACK_IMPORTED_MODULE_2__/* .CursiveBasic */ .x, {
                                        children: "100% real ingredients, no fillers"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ui__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, {
                                        className: "text-colorFifteen",
                                        children: "Big brand pet food manufacturers often use fillers that can be harmful for your dog's digestive system. We've been using only the best natural ingredients to make nutritious, healthy dog food since 1996. We learnt exactly what dogs need and what they love."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "py-10",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ui__WEBPACK_IMPORTED_MODULE_1__/* .ButtonWithArrow */ .Ub, {
                                    href: "/our-difference",
                                    center: true,
                                    className: "w-[310px] lg:w-[240px]",
                                    children: "Our Difference"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "space-y-3.5 pt-5",
                        children: BlockDifferenceCheckListData.map(function(item) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ui__WEBPACK_IMPORTED_MODULE_1__/* .CheckList */ .Su, {
                                title: item.title
                            }, item.id);
                        })
                    })
                ]
            })
        })
    });
};


/***/ }),

/***/ 4693:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ CursiveBasic; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);

var CursiveBasic = function(param) {
    var children = param.children, _className = param.className, className = _className === void 0 ? "" : _className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "m-auto font-madelyn text-sliderTitle text-colorSixteen lg:text-blockHeader ".concat(className),
        children: children
    });
};


/***/ })

}]);